"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderTemplate = renderTemplate;
const tslib_1 = require("tslib");
const fs_extra_1 = tslib_1.__importDefault(require("fs-extra"));
const handlebars_1 = tslib_1.__importDefault(require("handlebars"));
function renderTemplate(templateFilePath, context) {
    const templateContent = fs_extra_1.default.readFileSync(templateFilePath, "utf-8");
    const template = handlebars_1.default.compile(templateContent);
    const renderedContent = template(context);
    return renderedContent;
}
//# sourceMappingURL=renderTemplate.js.map